import React from "react";

export const Logo = ({ size = "default", showText = true, stacked = false }) => {
  const sizes = {
    small: { image: "h-10 w-10", title: "text-base", subtitle: "text-[10px]" },
    default: { image: "h-12 w-12", title: "text-lg", subtitle: "text-xs" },
    large: { image: "h-16 w-16", title: "text-2xl", subtitle: "text-sm" },
  };

  const config = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${stacked ? "flex-col text-center" : ""}`}>
      <img
        src="/assets/carefleet-logo-cropped.png"
        alt="CareFleet Transport Ltd"
        className={`${config.image} object-contain shrink-0 drop-shadow-sm`}
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-bold tracking-tight text-[#0F172A] ${config.title}`}>CareFleet</div>
          <div className={`font-medium uppercase tracking-[0.22em] text-[#B78A2A] ${config.subtitle}`}>
            Transport Ltd
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
